import * as React from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Paper from "@material-ui/core/Paper";
import { MuiThemeProvider } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import api from "../../store/api";
import Navbar from "../shared/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";
import { RootState } from "../../store/rootReducer";
import { useHistory, useParams } from "react-router";
import Snackbar from "@material-ui/core/Snackbar";
import { showNavbar } from "../../store/modules/appStateSlice";
import { IAppPropsWithRoute } from "../../common/types";
import theme from "../../components/shared/theme";
import { TextField } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import { SearchIcon as SearchIconCustom } from "../../assets/iconComponents/Icons";
import { Typography } from "@material-ui/core";
import { ISchedule } from "../../common/types";
import { getOriginLocationString, getDestinationLocationString, getAcuity } from "../../common/helpers";
import { AppBar, Toolbar, Theme } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import clsx from "clsx";
import Dialog from "@material-ui/core/Dialog";
import sub from "date-fns/sub";
import add from "date-fns/add";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import debounce from "lodash/debounce";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import isSameDay from "date-fns/isSameDay";
import startOfMonth from "date-fns/startOfMonth";
import endOfMonth from "date-fns/endOfMonth";
import { CSVLink } from "react-csv";
import { CloudDownloadIcon } from "../../assets/iconComponents/Icons";
import { filterLocationForPopup, getLocationsDataForPopup } from "../popup/hospitalPopupHelpers";
import { getDataFromStorage, setDataToStorage } from "../../common/sessionStorageHelpers";
import HospitalPopup from "../popup/HospitalPopup";
import ISelectItem from "../popup/types/ISelectItem";
import { consts } from "../../common/consts";
import _ from 'lodash';
import  downloadCloudicon  from "../../assets/svgs/download-icon.png";

interface TransferProps extends IAppPropsWithRoute { }

interface IUserData {
  givenName: string;
  surName: string;
  email: string;
  role: string;
  IsAdmin: boolean;
  exp: number;
  location: string;
  ward: string;
  IsCustomer?: boolean | null | undefined,
  CustomerId?: string | null | undefined,
}

interface IAuthState {
  isAuthenticated?: boolean;
  token: string | null;
  userName: string | null;
  data: IUserData | null;
  sessionExpired: boolean;
}

interface CSVDataObj {
  scheduledDate: string | null;
  bookingLocation: string | null;
  originName: string | null;
  destinationName: string | null;
  duration: string | null;
  distance: string | null;
  acuity: string | null;
  reasonDelay: string | null;
  currentStatus: string | null;
  discount: string | null;
}

interface IColumnList {
  columnName: string;
  columnCaption: string;
  selected: boolean;
}

interface ICsvHeader {
  label: string;
  key: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
    padding: "16px 0px 16px 0px",
  },
  table: {
    width: "100%",
    marginTop: 15,
  },
  muiTableBody: {
    backgroundColor: "#fff",
  },
  tableHead: {
    backgroundColor: "#FFF",
    "& > *": {
      fontSize: 18,
      fontWeight: 700,
      color: "#333333",
      height: 72,
      verticalAlign: "bottom",
      paddingBottom: 10,
    },
  },
  tableBody: {
    backgroundColor: "#FFF",
    cursor: "pointer",
    borderBottom: "1px solid #979797",
    "& > *": {
      fontSize: 18,
      fontWeight: 500,
      color: "#14191C",
    },
  },
  loading: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2, 0, 0, 50),
    },
  },
  dateFilterIcon: {
    color: "#0049a3",
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&:disabled": {
      color: "#02489D7F",
    },
  },
  buttonRoot: {
    padding: 0,
  },
  searchIcon: {
    color: "#FFF",
  },
  tableCell: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    paddingLeft: 10,
    paddingRight: 10,
  },
  dialogContent: {
    width: 360,
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    marginBottom: 15,
    overflow: "hidden",
  },
  popupCancel: {
    width: 163,
    height: 44,
    background: "#ECECEC",
    color: "#03090E",
    textTransform: "none",
    fontWeight: 700,
    fontSize: 19,
  },
  popupApply: {
    width: 163,
    height: 44,
    background: "#02489D",
    textTransform: "none",
    fontWeight: 700,
    fontSize: 19,
  },
}));

const useStylesSubHeader = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: "100%",
    },
    menuButton: {
      marginLeft: theme.spacing(1),
    },
    centerText: {
      color: "#FFF",
      fontSize: 18,
      fontWeight: 700,
      opacity: 0.36,
      textTransform: "none",
    },
    centerButton: {
      minWidth: 0,
      padding: "5px 15px",
    },
    arrowButton: {
      color: "#fff",
    },
    searchAndDownloadContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    whiteBtn: {
      color: "#FFF",
      opacity: 0.5,
      padding: 3,
    },
    searchBox: {
      color: "#FFF",
    },
    disabledBtn: {
      opacity: 0.5,
    },
  })
);

function NavRightMenu(props: any): JSX.Element {
  return (
    <Button onClick={props.rightButtonClick} endIcon={<KeyboardArrowDownIcon />} style={{ color: "#FFF" }}>
      {props.userName}
    </Button>
  );
}

const CreateLoadingLine = (props: any): JSX.Element => {
  const classes = useStyles();
  return (
    <div className={classes.loading} style={props.show ? { display: "" } : { visibility: "hidden" }}>
      <LinearProgress color="primary" />
    </div>
  );
};

const getTransferStatusString = (status: number) => {
  switch (status) {
    case 1:
      return "Requested";
    case 2:
      return "Scheduled";
    case 3:
      return "InProgress";
    case 4:
      return "Complete";
    case 5:
      return "Assigned To Me";
    case 6:
      return "Aborted";
    case 7:
      return "PickingUp";
    case 8:
      return "EnRoute To Destination";
    case 9:
      return "Dropping Off";
    case 10:
      return "Ended";
    case 11:
      return "Cancelled";
    default:
      return "Unknown";
  }
};

const PAGE_SIZE = 10;

const SORT_ORDER = {
  ASC: "asc",
  DESC: "desc",
};

const parseTime = (time: any): string => {
  if (typeof time === "string") return time;
  let d = new Date();
  if (time?.hours !== undefined && time?.minutes !== undefined && time?.ticks !== 0) {
    d.setHours(time?.hours);
    d.setMinutes(time?.minutes);
  } else return "-";
  return `${("0" + d.getHours()).slice(-2)}:${("0" + d.getMinutes()).slice(-2)}`;
};

const getTransferDate = (row: ISchedule) => {
  if (row.scheduledDate) return format(new Date(row.scheduledDate), "dd/M/y");
  else if (row.bookingDate) return format(new Date(row.bookingDate), "dd/M/y");
  return format(new Date(row.createdOn), "dd/M/y");
};

const getRoles = (authStore: IAuthState) => {
  const roles = {
    isAdmin: authStore?.data?.IsAdmin || false,
    SMADriver: authStore?.data ? (authStore?.data?.role?.indexOf("SMA Driver") >= 0 ? true : false) : false,
    CustomerDriver: authStore?.data ? (authStore?.data?.role?.indexOf("Customer Driver") >= 0 ? true : false) : false,
    hospitalAdministrator: authStore?.data?.role ? (authStore?.data?.role?.indexOf("Hospital Administrator") >= 0 ? true : false) : false,
    bookingCoordinator: authStore?.data?.role ? (authStore?.data?.role?.indexOf("Booking Coordinator") >= 0 ? true : false) : false,
    nurseStation: authStore?.data?.role
      ? authStore?.data?.role?.indexOf("Booking Coordinator") >= 0 || authStore?.data?.role?.indexOf("Ward") >= 0
        ? true
        : false
      : false, //&&
    SMAViewTransferHistory: authStore?.data?.role ? authStore?.data?.role?.indexOf("SMAViewTransferHistory") >= 0 : false,
    ViewCustomerTransferHistory: authStore?.data?.role ? authStore?.data?.role?.indexOf("ViewCustomerTransferHistory") >= 0 : false,
    isCustomer: authStore.data?.IsCustomer || false,
    canViewTransferHistoryAsSMA: authStore?.data?.role?.split(",")?.some((p) => p == consts.Permissions.SMAViewTransferHistory),
    IsNotSMAUser: authStore.data?.location !== undefined && authStore.data?.location !== null && authStore.data?.location !== "",
    IsCustomer: authStore?.data?.IsCustomer || false,
  };
  return {
    assignText: roles.isAdmin ? "Assign" : roles.SMADriver ? "Assign To Me" : "",
    subHeader: roles.isAdmin || roles.SMAViewTransferHistory || roles.ViewCustomerTransferHistory || roles.bookingCoordinator || roles.nurseStation ? true : false,
    hospitalSelectArrow: roles.isAdmin || roles.canViewTransferHistoryAsSMA || roles.isCustomer ? true : false,
    wardSwitch: roles.nurseStation && !roles.isAdmin,
    transerSwitch: roles.SMADriver || roles.isAdmin ? true : false,
    transerSwitchRightText: roles.isAdmin ? "Unassigned" : roles.SMADriver ? "Assigned To Me" : "",
    scheduleTransfer: roles.isAdmin || (roles.bookingCoordinator && !roles.nurseStation) ? true : false,
    hospitalSelectNavBar: roles.SMADriver && !roles.isAdmin ? true : false,
    transferCheckboxes: roles.SMADriver && !roles.isAdmin,
    isSMADriver: roles.SMADriver && !roles.isAdmin,
    isAdmin: roles.isAdmin,
    adminNavbar: roles.isAdmin,
    locationOval: roles.isAdmin,
    isHospitalAdmin: roles.hospitalAdministrator,
    IsNotSMAUser:roles.IsNotSMAUser,
    IsCustomer:roles.IsCustomer,
  };
};

const useStylesCheckBox = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: 3,
    width: 15,
    height: 15,
    backgroundColor: "#ECECEC",
  },
  checkedIcon: {
    backgroundColor: "#ECECEC",
    "&:before": {
      display: "block",
      width: 15,
      height: 15,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%2303090E'/%3E%3C/svg%3E\")",
      content: '""',
    },
  },
});

function StyledCheckbox(props: CheckboxProps) {
  const classes = useStylesCheckBox();

  return (
    <Checkbox
      className={classes.root}
      disableRipple
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      inputProps={{ "aria-label": "decorative checkbox" }}
      {...props}
    />
  );
}

const persistName = "transfers";

const getData = (value = "") => getDataFromStorage(persistName, value);

const setData = (key: string, value: any) => setDataToStorage(persistName, key, value);

function lowerCaseFirstLetter(string: string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

const PopupDownloadCol = ({ closeModalAction, isModalOpen, columnList, csvReport, saveTransferExportData, saveSelection, setSaveSelection }: any) => {
  const [searchText, setSearchText] = React.useState("");
  const classes = useStyles();

  return (
    <Dialog
      open={isModalOpen}
      PaperProps={{
        style: {
          backgroundColor: "#FFF",
        },
      }}
      onClose={closeModalAction}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
    >
      <DialogContent className={classes.dialogContent}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography style={{ color: "#14191C", fontWeight: 400, fontSize: 19 }} gutterBottom>
            Choose fields for export
          </Typography>
          <IconButton onClick={closeModalAction} aria-label="close">
            <CloseIcon style={{ color: "#000" }} />
          </IconButton>
        </div>
        <TextField
          id="filled-start-adornment"
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ color: "#707070" }} />
              </InputAdornment>
            ),
            style: { backgroundColor: "#ECECEC" },
          }}
          variant="outlined"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          autoComplete="off"
        />
      </DialogContent>
      <div style={{ height: 1, backgroundColor: "#979797" }}></div>
      <DialogContent
        style={{
          width: 360,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            height: 300,
            flexDirection: "column",
          }}
        >
          {columnList[0].map((item: any) => {
            if (
              searchText == "" ||
              (item.columnCaption?.indexOf(searchText) != undefined && item.columnCaption?.toLowerCase().indexOf(searchText.toLowerCase()) >= 0)
            ) {
              return (
                <Typography key={item.columnName} variant="h6" style={{ color: "#14191C", fontWeight: 400, fontSize: 19 }} gutterBottom>
                  <StyledCheckbox
                    onClick={() =>
                      columnList[1]((previousState: any[]) =>
                        previousState.map((i: any) => (i.columnName == item.columnName ? { ...i, selected: !i.selected } : i))
                      )
                    }
                    checked={item.selected}
                  />
                  {item.columnCaption}
                </Typography>
              );
            } else {
              return null;
            }
          })}
        </div>
      </DialogContent>
      <div style={{ height: 1, backgroundColor: "#979797" }}></div>
      <DialogContent
        style={{
          width: 360,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: "0.35em",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography variant="h6" style={{ color: "#14191C", fontWeight: 400, fontSize: 19 }} gutterBottom>
            <StyledCheckbox onClick={() => setSaveSelection((prev: any) => !prev)} checked={saveSelection} />
            Save my selection
          </Typography>
        </div>
      </DialogContent>

      <div style={{ height: 1, backgroundColor: "#979797" }}></div>
      <DialogContent
        style={{
          width: 360,
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 15,
            marginTop: 15,
          }}
        >
          <Button className={classes.popupCancel} variant="contained" color="primary" disableElevation onClick={closeModalAction}>
            Cancel
          </Button>
          {csvReport.data.length > 0 && (
            <CSVLink
              {...csvReport}
              onClick={(event: any, done: any) => {
                if (csvReport.data.length > 0) return true;
                return false;
              }}
            >
              <Button
                className={classes.popupApply}
                variant="contained"
                color="primary"
                disableElevation
                onClick={() => {
                  closeModalAction();
                  if (saveSelection) {
                    saveTransferExportData();
                  } else {
                    setTimeout(() => {
                      columnList[1]((prev: any) => {
                        return prev.map((item: any) => ({ ...item, selected: false }));
                      });
                    }, 0);
                  }
                }}
              >
                Download
              </Button>
            </CSVLink>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

// commented because - headers are now dynamic
// const headers = [
//     { label: "Date & Time", key: "scheduledDate" },
//     { label: "Hospital", key: "bookingLocation" },
//     { label: "From", key: "originName" },
//     { label: "To", key: "destinationName" },
//     { label: "Mins", key: "duration" },
//     { label: "Km", key: "distance" },
//     { label: "Acuity", key: "acuity" },
//     { label: "Status", key: "currentStatus" }
// ];

const SubHeader = ({ leftButtonClick, show, title = "All Hospitals", otherProps }: any) => {
  const classes = useStylesSubHeader();
  const { onSearchTextChange, endDay, startDay, setEndDay, setStartDay, setDateDialog, showCSVModalAction, loading, setFilterDataChanged, searchKey } = otherProps;
  let tempStartDay, tempEndDay;

  const onStartDateChanged = () =>{
    setDateDialog("startDay")
    setFilterDataChanged(true)
  }
  
  const onEndDateChanged = () =>{
    setDateDialog("endDay")
    setFilterDataChanged(true)
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ backgroundColor: "#01224A" }}>
        <Toolbar variant="dense" style={{ justifyContent: "space-between" }}>
          <span
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" style={{ color: "#FFF", fontSize: 18, fontWeight: 400 }}>
              {title}
            </Typography>
            {show.hospitalSelectArrow && (
              <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={leftButtonClick}>
                <KeyboardArrowDownIcon />
              </IconButton>
            )}
          </span>
          <span style={{ paddingLeft: 185 }}>
            <IconButton
              onClick={() =>
                isSameDay(startDay, endDay)
                  ? ((tempStartDay = sub(startDay, { days: 1 })),
                    (tempEndDay = sub(endDay, { days: 1 })),
                    setStartDay(tempStartDay),
                    setEndDay(tempEndDay),
                    setData("startDay", tempStartDay),
                    setData("endDay", tempEndDay))
                  : null
              }
              disabled={isSameDay(startDay, endDay) ? false : true}
              classes={{ disabled: classes.disabledBtn }}
              style={{ paddingTop: 8 }}
            >
              <KeyboardArrowLeftIcon className={classes.arrowButton} />
            </IconButton>
            <span style={{ cursor: "pointer" }} onClick={() => onStartDateChanged()}>
              {format(startDay, "dd LLL yyyy")} -{" "}
            </span>
            <span style={{ cursor: "pointer" }} onClick={() => onEndDateChanged()}>
              {format(endDay, "dd LLL yyyy")}
            </span>
            <IconButton
              onClick={() =>
                isSameDay(startDay, endDay)
                  ? ((tempStartDay = add(startDay, { days: 1 })),
                    (tempEndDay = add(endDay, { days: 1 })),
                    setStartDay(tempStartDay),
                    setEndDay(tempEndDay),
                    setData("startDay", tempStartDay),
                    setData("endDay", tempEndDay))
                  : null
              }
              disabled={isSameDay(startDay, endDay) ? false : true}
              classes={{ disabled: classes.disabledBtn }}
              style={{ paddingTop: 8 }}
            >
              <KeyboardArrowRightIcon className={classes.arrowButton} />
            </IconButton>
          </span>

          <span className={classes.searchAndDownloadContainer}>
            <div style={{ alignSelf: "flex-end", marginRight: 30 }} onClick={showCSVModalAction}>
              {/* <CloudDownloadIcon style={{ width: 24, height: 24, cursor: "pointer" }} /> */}
              <img style={{ width: 24, height: 22, cursor: "pointer"}} src={downloadCloudicon} />
            </div>
            {!loading ? (
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth={false}
                defaultValue={searchKey}
                style={{ margin: 0 }}
                inputRef={(input) => input?.focus()}
                onChange={(e) => (onSearchTextChange(e.target.value), setFilterDataChanged(true))}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon>
                        <SearchIconCustom />
                      </Icon>
                    </InputAdornment>
                  ),
                  style: { backgroundColor: "#1d4468", color: "#fff", borderRadius: 4 },
                }}
              />
            ) : (
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth={false}
                defaultValue={searchKey}
                style={{ margin: 0 }}
                disabled={loading}
                // className={classes.searchBox}
                onChange={(e) => (onSearchTextChange(e.target.value), setFilterDataChanged(true))}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Icon>
                        <SearchIconCustom />
                      </Icon>
                    </InputAdornment>
                  ),
                  style: { backgroundColor: "#1d4468", color: "#fff", borderRadius: 4 },
                }}
              />
            )}
          </span>
        </Toolbar>
      </AppBar>
    </div>
  );
};

function TransferHistory(props: TransferProps) {
  const {pageNumber} = useParams<{pageNumber: string }>();
  const classes = useStyles();
  const history = useHistory();
  const { authStore } = useSelector((state: RootState) => state);
  const { bookingToast } = useSelector((state: RootState) => state.appState);
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [firstloadscheduleHistoryList, setfirstloadScheduleHistoryList] = React.useState<ISchedule[]>([]);
  const [scheduleHistoryList, setScheduleHistoryList] = React.useState<ISchedule[]>([]);
  const [pageTransferids, setpageTransferids] = React.useState<any[] | null>(null);
  const [selectedHospital, setSelectedHospital] = React.useState<any>("All Hospitals");
  const popState = React.useState(false);
  const [showDownloadCSVModal, setShowDownloadCSVModal] = React.useState(false);
  const show = getRoles(authStore);
  const locationState = React.useState<ISelectItem[]>([]);
  const columnList = React.useState<IColumnList[]>([]);
  const [selectedLocations, setSelectedLocations] = React.useState<any>(getData("selectedLocations") || []);
  const [startDay, setStartDay] = React.useState(getData("startDay") ? new Date(getData("startDay")) : startOfMonth(new Date()));
  const [endDay, setEndDay] = React.useState(getData("endDay") ? new Date(getData("endDay")) : endOfMonth(new Date()));
  // const [searchKey, setSearchKey] = React.useState("");
  const [searchKey, setSearchKey] = React.useState(localStorage.getItem("searchKey")!=null ? localStorage.getItem("searchKey") : "");
  const [dateDialog, setDateDialog] = React.useState<string | null>(null);
  const [csvDataSet, setCsvDataSet] = React.useState<any[]>([]);
  const [saveSelection, setSaveSelection] = React.useState(false);
  var pg  = (pageNumber!=null && pageNumber!=undefined && pageNumber!='') ? Number(pageNumber) : 0
 const [page, setPage] = React.useState(Number(pg) ?? 0);
  const [recordCount, setRecordCount] = React.useState(0);
  const [sortOrder, setSortOrder] = React.useState(SORT_ORDER.DESC);
  const [searchval, setsearchval] = React.useState(false);
  const [filterDataChanged, setFilterDataChanged] = React.useState(false);
  const [csvReport, setCsvReport] = React.useState<any>({
    data: [],
    headers: [],
    filename: "Transfers.csv",
  });

  React.useEffect(() => {
    if (csvDataSet.length > 0) {
      setCsvReport({
        data: csvDataSet,
        headers: columnList[0]
          .filter((item) => item.selected)
          .map((item: IColumnList) => {
            return { label: item.columnCaption, key: lowerCaseFirstLetter(item.columnName) };
          }),
        filename: "Transfers.csv",
      });
    }
  }, [columnList[0], csvDataSet]);

  const renderRowData = (row: ISchedule, index: number) => {
    let formatRow: any = {
      ...row,
      scheduledDate: row.scheduledDate ? format(new Date(row.scheduledDate), "dd/MM/yyyy HH:mm") : "",
      requestedTransferDate: row.bookingDate ? format(new Date(row.bookingDate), "dd/MM/yyyy") : "",
      bookingLocation: row.originLocationName || row.destinationLocationName || "-",
      originName: getOriginLocationString(row,false,true),
      destinationName: getDestinationLocationString(row,false,true),
      duration: row.mins,
      distance: row.kms,
      acuity: getAcuity(row),
      reasonDelay: row.reasonForThisTime,
      currentStatus: getTransferStatusString(row.status),
      discount: "",
      createdOn: row.createdOn ? format(new Date(row.createdOn), "dd/MM/yyyy HH:mm") : "",
      modifiedOn: row.modifiedOn ? format(new Date(row.modifiedOn), "dd/MM/yyyy HH:mm") : "",
      billingChargeValue: (String(row.billingType) === '5' && show?.isAdmin === false) ? "" : row.billingChargeValue,
      billingSubTotals: (String(row.billingType) === '5' && show?.isAdmin === false) ? "" : row.billingSubTotals,
      discountValue: (String(row.billingType) === '5' && show?.isAdmin === false) ? "" : row.discountValue,
      netTransferFee: (String(row.billingType) === '5' && show?.isAdmin === false) ? "" : row.netTransferFee,
    };
    return formatRow;
  };

  const debouncedgetScheduleHistoryList = React.useCallback(
    _.debounce((showAll,filter) => {
      getScheduleHistoryList(showAll,filter);
    }, 1000), // 1000 milliseconds delay
    []
  );

  const getScheduleHistoryList = async (showAll: boolean, filter:any) => {
    setLoading(true);
    localStorage.setItem("searchKey",String(filter.searchKey));
      const _res = await api.getTransferHistoryListByPage("", filter);
      if (_res !== null && _res.data !== null && _res.data.model !== null && !_res.data.hasError) {
        if (_res?.data !== null && _res?.data?.model !== null) {
          let _scheduleList: ISchedule[] = _res?.data?.model?.transferResponseList;
          let _totalscheduleList: ISchedule[] = _res?.data?.model?.transferTotalResponseList;
          // columnList[1](_res.data.model.transferExportFields.exportColumns);
          // setSaveSelection(_res.data.model.transferExportFields.saveSelection);
          setScheduleHistoryList([]);
          if (_scheduleList !== null) {
            setScheduleHistoryList(_scheduleList);
            
          }
          if(filter.transferIds == null){
            setRecordCount(_res?.data?.model?.recordTotal);
            if (_totalscheduleList !== null)
              setfirstloadScheduleHistoryList(_totalscheduleList);
          }
        } else if (_res?.data === 0 || _res?.data?.model === 0) {
          setRecordCount(0);
          setScheduleHistoryList([])
          setfirstloadScheduleHistoryList([]);
        }
      } else {
        setRecordCount(0);
        setScheduleHistoryList([])
        setfirstloadScheduleHistoryList([]);
      }
      setLoading(false);
}

  const showCSVModalAction = async () => {
    try {

      setLoading(true);
      const filter = {
        scheduledStartDate: format(startDay, "yyyy-MM-dd"),
        scheduledEndDate: format(endDay, "yyyy-MM-dd"),
        searchKey: searchKey,
        pageNumber: page + 1,
        pageSize: PAGE_SIZE,
        sortColumn: "scheduledDate",
        sortDirection: sortOrder,
        locationId: selectedLocations,
        CustomerId: authStore.data?.CustomerId || null
      };
      const _res = await api.getTransferHistoryList("", filter);
      if (_res !== null && _res?.data !== null && _res?.data?.model !== null && !_res?.data?.hasError) {
        let _scheduleList: ISchedule[] = _res?.data?.model?.transferResponseList;
        columnList[1](_res?.data?.model?.transferExportFields?.exportColumns);
        setSaveSelection(_res?.data?.model?.transferExportFields?.saveSelection);
        if (_scheduleList !== null) {
          setCsvDataSet(_scheduleList.map(renderRowData));
        }
        setShowDownloadCSVModal(true);
      }
      setLoading(false);
    }
    catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setFilterDataChanged(false);
    getLocationsData();
    dispatch(showNavbar(false));
  }, []);

  const saveTransferExportData = () => {
    api.saveTransferExportUserSelection("", {
      selectedColumns: columnList[0].filter((item) => item.selected).map((item) => item.columnName),
      saveSelection: true,
    });
  };

  React.useEffect(() => {
    let _allowrequest:boolean=false;
    if (show.isAdmin==true )
      _allowrequest=true;
    else if (show.isAdmin==false && selectedLocations.length!=0)
      _allowrequest=true;
      else if(!show.isAdmin)
      _allowrequest=true;
    if(_allowrequest && filterDataChanged){
    setPage(0);
    setpageTransferids(null);
    getScheduleHistoryList(false, {
      scheduledStartDate: format(startDay, "yyyy-MM-dd"),
      scheduledEndDate: format(endDay, "yyyy-MM-dd"),
      searchKey,
      pageNumber: 1,
      pageSize: PAGE_SIZE,
      sortColumn: "sortingDate",
      sortDirection: sortOrder,
      locationId: selectedLocations,
      transferIds: null,
      CustomerId:authStore.data?.CustomerId||null
    });
    }
  }, [selectedLocations]);


  React.useEffect(() => {
    let _allowrequest: boolean = false;
    if (show.isAdmin || show.hospitalSelectArrow)
      _allowrequest = true;
    else if (!show.isAdmin && selectedLocations.length != 0)
      _allowrequest = true;
    else if (!show.isAdmin)
      _allowrequest = true;
    if (_allowrequest) {
      if (page == 0) {
        setpageTransferids(null);
        debouncedgetScheduleHistoryList(false, {
          scheduledStartDate: format(startDay, "yyyy-MM-dd"),
          scheduledEndDate: format(endDay, "yyyy-MM-dd"),
          searchKey: searchKey,
          pageNumber: page + 1,
          pageSize: PAGE_SIZE,
          sortColumn: "sortingDate",
          sortDirection: sortOrder,
          locationId: selectedLocations,
          transferIds: null,
          CustomerId: authStore.data?.CustomerId || null
        });
      }
      else if (filterDataChanged) {
        setPage(0)
      }
      else {
        var pgnumber = (pageNumber != null && pageNumber != undefined && pageNumber != '') ? Number(pageNumber) : 0
        setPage(pgnumber);
      }
    }
    else {
      var pgnumber = (pageNumber != null && pageNumber != undefined && pageNumber != '') ? Number(pageNumber) : 0
      setPage(pgnumber);
    }
  }, [startDay, endDay, searchKey, sortOrder]);


  React.useMemo(()=>{  
    let _allowrequest:boolean=false;
    if (show.isAdmin==true )
      _allowrequest=true;
    else if (show.isAdmin==false && selectedLocations.length!=0)
      _allowrequest=true;
    else if(!show.isAdmin)
      _allowrequest=true;
    if(_allowrequest && filterDataChanged){
    setPage(0);
    setRecordCount(0);
    setsearchval(true)
    setpageTransferids(null);
    debouncedgetScheduleHistoryList(false, {
      scheduledStartDate: format(startDay, "yyyy-MM-dd"),
      scheduledEndDate: format(endDay, "yyyy-MM-dd"),
      searchKey:searchKey,
      pageNumber: 1,
      pageSize: PAGE_SIZE,
      sortColumn: "sortingDate",
      sortDirection: sortOrder,
      locationId: selectedLocations,
      transferIds: null,
      CustomerId:authStore.data?.CustomerId||null
    });
    }
      
  },[searchKey])

  React.useEffect(() => {
    let _allowrequest: boolean = false;
    if (show.isAdmin || show.hospitalSelectArrow)
      _allowrequest = true;
    else if (!show.isAdmin && selectedLocations.length != 0)
      _allowrequest = true;
    else if (!show.isAdmin)
      _allowrequest = true;
    if (_allowrequest) {
      getScheduleHistoryList(false, {
        scheduledStartDate: format(startDay, "yyyy-MM-dd"),
        scheduledEndDate: format(endDay, "yyyy-MM-dd"),
        searchKey,
        pageNumber: page + 1,
        pageSize: PAGE_SIZE,
        sortColumn: "sortingDate",
        sortDirection: sortOrder,
        locationId: selectedLocations,
        transferIds: null,//transferids == null ? null : transferids,
        CustomerId: authStore.data?.CustomerId || null
      });
    }
  }, [page]);

  const handleChangePage = (event: any, newPage: any) => { 
    setPage(newPage);
  };


  const handlePickerDateChange = (date: Date | null) => {
    if (date == null) return;
    if (dateDialog == "endDay") {
      setEndDay(date);
      setData("endDay", date);
    } else {
      setStartDay(date);
      setData("startDay", date);
    }
    setDateDialog(null);
  };

  const renderRow = (row: ISchedule, index: number) => {
    return (
      <TableRow
        onClick={(e) => history.push(`/transferFullDetails/${row.bookingId}/${row.transferId}/${(page).toString()}`, { duration: row.mins })}
        hover
        key={row.transferId}
        className={classes.tableBody}
      >
        <TableCell className={classes.tableCell}>{getTransferDate(row)}</TableCell>
        <TableCell className={classes.tableCell}>{row.bookingNumber}</TableCell>
        <TableCell className={classes.tableCell}>{`${row.firstName} ${row.lastName}`}</TableCell>
        <TableCell className={classes.tableCell}>{`${row.scheduledDate ? format(new Date(row.scheduledDate), "HH:mm") : "-"} / ${parseTime(
          row.pickupActualTime
        )}`}</TableCell>
        <TableCell className={classes.tableCell}>{row.ownerLocation || "-"}</TableCell>
        <TableCell className={classes.tableCell}>{getOriginLocationString(row)}</TableCell>
        <TableCell className={classes.tableCell}>{getDestinationLocationString(row)}</TableCell>
        <TableCell className={classes.tableCell}>{row.fleet || "-"}</TableCell>
        <TableCell className={classes.tableCell}>{row.kms || "-"}</TableCell>
        <TableCell className={classes.tableCell}>{row.mins || "-"}</TableCell>
        <TableCell className={classes.tableCell}>{row.delayed ? "Yes" : "No"}</TableCell>
        <TableCell style={{ paddingRight: 5 }} className={classes.tableCell}>
          {getTransferStatusString(row.status)}
        </TableCell>
      </TableRow>
    );
  };

  const getLocationsData = async (): Promise<void> => {
    await getLocationsDataForPopup(locationState, setSelectedHospital, setSelectedLocations, selectedLocations, persistName);
  };

  const filterLocation = () => {
    setFilterDataChanged(true);
    filterLocationForPopup(locationState, setSelectedHospital, setSelectedLocations, persistName);
  };

  return (
    <React.Fragment>
      <MuiThemeProvider theme={theme}>
        {authStore?.data?.IsAdmin ? (
          <Navbar rightButton={<NavRightMenu userName={authStore?.data?.givenName ?? ""} />} />
        ) : (
          <Navbar rightButton={<NavRightMenu userName={authStore?.data?.givenName ?? ""} />} />
        )}
        {show.subHeader && (
          <div style={loading ? { pointerEvents: "none", opacity: "0.4" } : {}}>
            <SubHeader
              show={show}
              title={selectedHospital}
              leftButtonClick={() => popState[1](true)}
              otherProps={{ onSearchTextChange: setSearchKey, endDay, startDay, setEndDay, setStartDay, setDateDialog, showCSVModalAction, loading, setFilterDataChanged, searchKey }}
            />
          </div>
        )}
        <Paper style={{ height: "100vh", paddingBottom: 100, borderRadius: 0 }}>
          <div style={{ marginTop: 5, marginBottom: 20 }}>
            <CreateLoadingLine show={loading} />
          </div>
         
          <Table className={classes.table}>
            <TableRow>
              <TableCell
                style={{
                  paddingBottom: 5,
                  paddingTop: 5,
                  paddingLeft: 0,
                  paddingRight: 0,
                  borderBottom: "none",
                }}
                colSpan={0}
              >
                <Box margin={0} style={loading ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                  <Table size="small" aria-label="purchases" style={{ tableLayout: "fixed" }}>
                    <TableHead>
                      <TableRow className={classes.tableHead}>
                        <TableCell width="5%" align="left" style={{ minWidth: 100 }}>
                          Date{" "}
                          <IconButton
                            classes={{ root: classes.buttonRoot }}
                            onClick={() => setSortOrder(sortOrder === SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC)}
                          >
                            <KeyboardArrowDownIcon
                              style={{ padding: 0, marginBottom: 0, ...(sortOrder === SORT_ORDER.DESC ? { transform: "rotate(180deg)" } : {}) }}
                            />
                          </IconButton>
                        </TableCell>
                        <TableCell width="5%" align="left">
                          Booking ID
                        </TableCell>
                        <TableCell width="5%" align="left">
                          Patient
                        </TableCell>
                        <TableCell width="5%" align="left" style={{ minWidth: 120, paddingLeft: 0, paddingRight: 0 }}>
                          Pickup <br />
                          Sched / Actual
                        </TableCell>
                        <TableCell width="8%" align="left">
                          Hospital
                        </TableCell>
                        <TableCell width="8%" align="left">
                          From
                        </TableCell>
                        <TableCell width="8%" align="left">
                          To
                        </TableCell>
                        <TableCell width="8%" align="left">
                          Fleet
                        </TableCell>
                        <TableCell width="4%" align="left">
                          Km
                        </TableCell>
                        <TableCell width="3%" align="left">
                          Mins
                        </TableCell>
                        <TableCell width="3%" align="left" style={{ paddingLeft: 0 }}>
                          Delay?
                        </TableCell>
                        <TableCell width="4%" align="left">
                          Status
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>{scheduleHistoryList.map(renderRow)}</TableBody>
                  </Table>
                  {scheduleHistoryList.length <= 0 && <div style={{ display: "flex", justifyContent: "center" }}>No Records found</div>}
                </Box>
              </TableCell>
            </TableRow>
          </Table>

          <TablePagination
            rowsPerPageOptions={[PAGE_SIZE]}
            component="div"
            count={recordCount}
            rowsPerPage={PAGE_SIZE}
            page={page}
            onChangePage={handleChangePage}
            style={loading ? { pointerEvents: "none", opacity: "0.4" } : {}}
          />
        </Paper>
        <HospitalPopup popState={popState} filterLocation={filterLocation} locationState={locationState} />
        <PopupDownloadCol
          closeModalAction={() => setShowDownloadCSVModal(false)}
          isModalOpen={showDownloadCSVModal}
          columnList={columnList}
          csvReport={csvReport}
          saveTransferExportData={saveTransferExportData}
          saveSelection={saveSelection}
          setSaveSelection={setSaveSelection}
        />

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={bookingToast ? bookingToast.open : false}
          message={bookingToast ? bookingToast.message : ""}
        />
      </MuiThemeProvider>
      <Dialog onClose={() => setDateDialog(null)} open={dateDialog != null}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <KeyboardDatePicker
            variant="static"
            format="d MMM yyyy"
            // maxDate={dateDialog == "endDay" ? new Date() : endDay}
            // minDate={dateDialog == "endDay" ? startDay : 0}
            value={dateDialog == "endDay" ? endDay : startDay}
            onChange={handlePickerDateChange}
          />
        </MuiPickersUtilsProvider>
      </Dialog>
    </React.Fragment>
  );
}

export default React.memo(TransferHistory);
